import React from 'react';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  video: {
    position: 'relative',
    width: '100%',
    height: `calc(100% - ${theme.spacing(6.5)})`,
    top: theme.spacing(6.5),
  },
}));

interface Props {
  src: string;
}
const Video: React.FC<Props> = ({ src }) => {
  const { classes } = useStyles();

  return (
    <iframe
      src={src}
      className={classes.video}
      data-test-locator="gallery-video"
      allowFullScreen
      scrolling="no"
      frameBorder="0"
    />
  );
};

export { Video };
